// extracted by mini-css-extract-plugin
export default {"buttons_container":"profile-user-information-page_buttons_container__Kjf6E"};